import { createIcon } from "@chakra-ui/react";

export const Minus = createIcon({
  displayName: "Minus",
  viewBox: "0 0 24 24",
  path: [
    <path
      fill="currentColor"
      d="M24 12c0 6.628-5.372 12-12 12S0 18.628 0 12 5.372 0 12 0s12 5.372 12 12zM12 2.25A9.749 9.749 0 0 0 2.25 12 9.749 9.749 0 0 0 12 21.75 9.749 9.749 0 0 0 21.75 12 9.749 9.749 0 0 0 12 2.25z"
    />,
    <path
      fill="currentColor"
      d="M7.875 13.125h8.25c.375 0 1.125-.325 1.125-1.125 0-.623-.502-1.125-1.125-1.125h-8.25c-.623 0-1.125.502-1.125 1.125 0 .4.25 1.125 1.125 1.125z"
    />,
  ],
  defaultProps: {
    "aria-label": "Minus symbol: A horizontal line within a hollow circle"
  }
});

export default Minus;
